import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Pipe({
  name: 'pageUrl',
})
export class PageUrlPipe implements PipeTransform {
  constructor(public route: ActivatedRoute) {}

  transform(
    value: number
  ): [string, number] | [string, number, string, number] | (string | number)[] {
    const path: string[] = this.route.snapshot.url
      ? this.route.snapshot.url.slice(2).map((segment) => segment.path)
      : [];

    if (path.length) {
      const newPath = [
        '/page',
        value,
        ...path.map((segment, index) => {
          if (parseInt(segment)) {
            return parseInt(segment);
          } else {
            return segment;
          }
        }),
      ];

      return newPath;
    }

    return ['/page', value];
  }
}
